import { useDeleteAtmServiceProvider } from "./api/deleteAtmServiceProvider";
import { Button } from "reactstrap";


const DeleteAtmServiceProvider = ({handleCloseModal, atmServiceProviderId}: DeleteAtmServiceProviderProps)  => {
  
  const deleteAtmServiceProviderMutation = useDeleteAtmServiceProvider({ atmServiceProviderId});
  const handleSubmit = async (): Promise<void> => {
    deleteAtmServiceProviderMutation.mutateAsync({ 
      atmServiceProviderId: atmServiceProviderId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε το ATM ServiceProvider;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteAtmServiceProviderProps{
  atmServiceProviderId: number;
  handleCloseModal: () => void;
}

export default DeleteAtmServiceProvider;